module.exports = __webpack_public_path__ + "img/coin_card.5cde1508.png";